import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  TBctxItemWithoutSizeAndBctxKey,
  TWipPackerStore,
  TWipPackerLIneMap,
  TWipPackerSizeToWipMap,
} from '@monorepo/types';
import { BCTXComputationHelper } from '@monorepo/utils';
import { getBctxItemsOrderWithoutSize, selectedShift, selectedSubject } from '@monorepo/core-data';

export const selectWipPackerStore = createFeatureSelector<TWipPackerStore>('WIP_PACKER_STORE');

export const getBctxItemWithoutSizeAndBctxKeyList = createSelector(
  selectWipPackerStore,
  getBctxItemsOrderWithoutSize,
  (wipPackerStore, bctxKeysOrder) => {
    const bctxList: TBctxItemWithoutSizeAndBctxKey[] = [];
    let uniqueBctxKeys: string[] = [];
    wipPackerStore.bctxData.res.forEach((bctxData) => {
      const bctxItemListWithoutSize = BCTXComputationHelper.filterBctxItemsWithKeys(bctxKeysOrder, bctxData.bctx_items);
      const bctx_key = BCTXComputationHelper.getUniqueBctxKeyWithOrder(bctxKeysOrder, bctxItemListWithoutSize);
      const bctxItemWithoutSizeAndBctxKeyItem: TBctxItemWithoutSizeAndBctxKey = {
        list: bctxItemListWithoutSize,
        bctxKey: bctx_key,
      };
      if (!uniqueBctxKeys.includes(bctx_key)) {
        uniqueBctxKeys.push(bctx_key);
        bctxList.push(bctxItemWithoutSizeAndBctxKeyItem);
      }
    });
    return bctxList;
  },
);

export const getSelectedBctx = createSelector(selectWipPackerStore, (state) => state.selectedBctx);

export const getSelectedBctxHeader = createSelector(selectWipPackerStore, (state) => state.selectedBctxHeader);

export const getLineMap = createSelector(selectWipPackerStore, (state) => state.lineMap);

export const getCurrentCartons = createSelector(selectWipPackerStore, (state) => state.currentCartons);

export const getOpenCurrentCartons = createSelector(selectWipPackerStore, (state) => {
  return state.currentCartons.filter((carton) => carton.status === 'OPEN');
});

export const getCartonList = createSelector(selectWipPackerStore, (state) => state.cartonList);

export const getFailedEvents = createSelector(selectWipPackerStore, (state) => state.failedEvents);

export const getCounts = createSelector(selectWipPackerStore, (state) => state.counts);

export const getUndoList = createSelector(selectWipPackerStore, (state) => state.undoList);
